<template>
  <div class="country-list">
    <div class="page-header">
      <h1 class="preH2">{{labels.pageListTitle}}</h1>
      <h2 class="uppercase" v-if="labels.pageListSubtitle">{{labels.pageListSubtitle}}</h2>
      <div class="header-intro" v-if="labels.pageListIntro">{{labels.pageListIntro}}</div>
    </div>
    <div class="country-groups" v-if="!isAsianLanguage">
      <LetterIndex :letters="countryGroups" link-prefix="group_"></LetterIndex>
      <a class="map-link" @click="showWorldMap">{{labels.worldMap}}</a>
      <div class="group-container">
        <CountryGroup v-for="(g, index) in countryGroups" :key="index" :name="g">
          <CountryLink v-for="c in filterCountries(g)" :key="c.id" :country="c"></CountryLink>  
        </CountryGroup>
      </div>
    </div>
    <div class="country-groups asian" v-if="isAsianLanguage">
      <a class="map-link" @click="showWorldMap">{{labels.worldMap}}</a>
      <div class="group-container">
        <CountryLink v-for="c in countries" :key="c.id" :country="c"></CountryLink>
      </div>
    </div>
    <Modal :visible="showMap" @close="showMap = false" :title="labels.allClariantLocations">
      <Map :pins="locations"></Map>
    </Modal>
  </div>
</template>

<script>
import {Labels, DataLayer, Utils, State, Monitoring} from "../services.js";
import CountryLink from "./CountryLink.vue";
import CountryGroup from "./CountryGroup.vue";
import LetterIndex from "./LetterIndex.vue";
import Modal from "./Modal.vue";
import Map from './Map.vue';

export default {
  name: 'CountryList',
  components: {
    CountryLink,
    CountryGroup,
    LetterIndex,
    Modal,
    Map
  },
  data () {
    return {
      labels: Labels,
      isAsianLanguage: false,
      countries: State.get("countries"),
      showMap: false,
      locations: State.get("locations"),
      triedLoading: false
    }
  },
  mounted() {
    State.subscribe("CountryList", this.onStateChange);
    const body = document.body;
    if (body) {
      if (body.classList.contains("lang-zh-CN") ||
        body.classList.contains("lang-ja-JP")) {
          this.isAsianLanguage = true;
        }
    }
  },
  beforeDestroy() {
    State.unsubscribe("CountryList");
  },
  computed: {
    countryGroups () {
      if (this.countries.length === 0) return [];
      return [...new Set(this.countries.map(x => x.firstLetter))];
    }
  },
  methods: {
    filterCountries(firstLetter) {
      return this.countries.filter(x => x.firstLetter === firstLetter);
    },
    showWorldMap() {
      this.showMap = true;
      if (this.locations.length === 0) {
        //we need to load the locations first
        Monitoring.startActivity("Loading locations");
        let loader = Utils.showLoader(".modal > .modal-body");
        DataLayer.getLocations().then(res => {
          State.set("locations", res.data);
        }).catch(err => {
          Utils.showStatusMessage(`Could not load location list! ${err}.`,"red",5000);
        }).finally(() => {
          Utils.removeLoader(loader);
          Monitoring.endActivity("Loading locations");
        });
      } 
    },
    onStateChange(message, prop, value, internalState) {
      if (!prop || !value) return;
      if (prop === "countries") {
        console.log(`State changed. Re-loading countries.`);
        this.countries = State.get("countries");
      } else if (prop === "locations") {
        this.locations = State.get("locations");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.country-groups {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.country-groups > .group-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
}

.country-groups.asian > .group-container > div.country-link {
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}

a.map-link {
  margin: 0 20px 30px 20px;
  display: block;
  font-weight: 500;
  padding-left: 25px;
  cursor: pointer;
  background-position: 0 50%;
  background-repeat: no-repeat;

}

@media all and (max-width:480px) {
 .country-groups.asian > .group-container > div.country-link {
    width: 100%;
    max-width: 150px;
  }
}
</style>
